import { IPage } from "../entities/page";
import {
  IBucketCreateRequest,
  IBucketDetailsItem,
  IBucketListItem,
  IBucketPageRequestParams,
  IBucketUpdateRequest,
} from "../entities/bucket";
import { DataService } from "./data-service";
import {
  IEntityUsageHistoryItemResponse,
  IEntityMetricsResponse,
  IEntityUsageHistoryRequest,
} from "api/entities/metrics";

class BucketService extends DataService {
  constructor() {
    super("bucket", 2);
  }

  getPage(
    requestParams: IBucketPageRequestParams,
  ): Promise<IPage<IBucketListItem>> {
    return this.api.get<IPage<IBucketListItem>>(null, requestParams);
  }

  get(bucketId: string): Promise<IBucketDetailsItem> {
    return this.api.get<IBucketDetailsItem>(bucketId, null);
  }

  getMetrics(id: string): Promise<IEntityMetricsResponse[]>;
  getMetrics(ids: string[]): Promise<IEntityMetricsResponse[]>;
  async getMetrics(ids: string | string[]): Promise<IEntityMetricsResponse[]> {
    const idList = Array.isArray(ids) ? ids : [ids];

    return Promise.resolve(
      idList.map((id, index) => ({
        id,
        sizeBytes: Math.pow(1024, 4) * (index + 1),
        objectNumber: 140627 + index * 25,
        status: index % 2 === 0 ? "up" : "down",
        metricsUpdateDateTime: Math.floor(
          new Date().getTime() / 1000,
        ).toString(),
      })),
    );
  }

  async getUsageHistory(
    params: IEntityUsageHistoryRequest,
  ): Promise<IEntityUsageHistoryItemResponse[]> {
    const now = new Date();

    return Promise.resolve([
      {
        itemid: params.id,
        clock: Math.floor(new Date(now.getTime() - 24 * 60 * 60 * 1000).getTime() / 1000).toString(),
        value: { size: Math.pow(1024, 2), count: 10 },
        ns: "bucket",
      },
      {
        itemid: params.id,
        clock: Math.floor(new Date(now.getTime() - 12 * 60 * 60 * 1000).getTime() / 1000).toString(),
        value: { size: Math.pow(1024, 3), count: 18872 },
        ns: "",
      },
      {
        itemid: params.id,
        clock: Math.floor(now.getTime() / 1000).toString(),
        value: { size: Math.pow(1024, 4), count: 140627 },
        ns: "",
      },
    ]);
  }

  create(request: IBucketCreateRequest) {
    return this.api.post<IBucketListItem>(null, request);
  }

  update(id: string, request: IBucketUpdateRequest) {
    return this.api.put<IBucketListItem>(id, request);
  }

  delete(id: string) {
    return this.api.delete<IBucketListItem>(id);
  }
}

export const bucketService = new BucketService();
